export type AccessPage = {
  key: string;
  label: string;
  path: string;
};

export const ACCESS_PAGES: AccessPage[] = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard" },
  { key: "finance", label: "Financeiro", path: "/financial-management" },
  { key: "transactions", label: "Lançamentos", path: "/financial-management" },
  { key: "recurring-expenses", label: "Gastos recorrentes", path: "/recurring-expenses" },
  { key: "goals", label: "Metas", path: "/financial-goals" },
  { key: "ai-advisor", label: "Planejamento com IA", path: "/financial-advisor" },
  { key: "configurations", label: "Configurações", path: "/configurations" },
  { key: "payment", label: "Pagamentos", path: "/payment" },
];

export const PUBLIC_PATHS = [
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/send-email-forgot-password",
  "/terms",
  "/privacy-policy",
];

export function normalizeAccessPages(pages: Partial<AccessPage>[] | null | undefined): AccessPage[] {
  if (!Array.isArray(pages) || pages.length === 0) {
    return ACCESS_PAGES;
  }

  return pages.map((page) => ({
    key: page.key || "",
    label: page.label || page.key || "",
    path: ACCESS_PAGES.find((item) => item.key === page.key)?.path || `/${page.key}`,
  }));
}

export function canAccessPage(allowedPages: string[] | null | undefined, pageKey?: string): boolean {
  if (!pageKey) {
    return true;
  }

  if (!Array.isArray(allowedPages) || allowedPages.length === 0) {
    return true;
  }

  return allowedPages.includes(pageKey);
}

export function firstAllowedPath(allowedPages: string[] | null | undefined): string {
  const page = ACCESS_PAGES.find((item) => canAccessPage(allowedPages, item.key));
  return page ? page.path : "/dashboard";
}
